(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("create-react-class"), require("uu5g04"), require("uu5g04-bricks"), require("uu5g04-forms"), require("module"));
	else if(typeof define === 'function' && define.amd)
		define("UuContentkitg01", ["react", "prop-types", "create-react-class", "uu5g04", "uu5g04-bricks", "uu5g04-forms", "module"], factory);
	else if(typeof exports === 'object')
		exports["UuContentkitg01"] = factory(require("react"), require("prop-types"), require("create-react-class"), require("uu5g04"), require("uu5g04-bricks"), require("uu5g04-forms"), require("module"));
	else
		root["UuContentkitg01"] = factory(root["React"], root["PropTypes"], root["createReactClass"], root["UU5"], root["UU5.Bricks"], root["UU5.Forms"], root["undefined"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_10__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(14);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var mod = __webpack_require__(10);
var uri = ((mod ? mod.uri : (document.currentScript || Array.prototype.slice.call(document.getElementsByTagName("script"), -1)[0] || {}).src) || "").toString();
__webpack_require__.p = uri.split(/\//).slice(0, -1).join("/") + "/"; // runtime publicPath configuration required for proper linking of styles, background images, ...
module.exports = __webpack_require__(11);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var bricks_namespaceObject = {};
__webpack_require__.d(bricks_namespaceObject, "BlockInfo", function() { return BlockInfo; });
__webpack_require__.d(bricks_namespaceObject, "BlockDanger", function() { return BlockDanger; });
__webpack_require__.d(bricks_namespaceObject, "BlockWarning", function() { return BlockWarning; });
__webpack_require__.d(bricks_namespaceObject, "BlockDefault", function() { return BlockDefault; });
__webpack_require__.d(bricks_namespaceObject, "BlockSuccess", function() { return BlockSuccess; });
__webpack_require__.d(bricks_namespaceObject, "BlockHelp", function() { return BlockHelp; });
__webpack_require__.d(bricks_namespaceObject, "BasicInfo", function() { return bricks_basic_info; });
var bricks_editable_namespaceObject = {};
__webpack_require__.d(bricks_editable_namespaceObject, "Block", function() { return block_Block; });

// EXTERNAL MODULE: external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
var external___amd___react___commonjs___react___commonjs2___react___root___React__ = __webpack_require__(0);
var external___amd___react___commonjs___react___commonjs2___react___root___React___default = /*#__PURE__*/__webpack_require__.n(external___amd___react___commonjs___react___commonjs2___react___root___React__);

// EXTERNAL MODULE: external {"amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types","root":"PropTypes"}
var external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes__ = __webpack_require__(1);
var external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes__);

// EXTERNAL MODULE: external {"amd":"create-react-class","commonjs":"create-react-class","commonjs2":"create-react-class","root":"createReactClass"}
var external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass__ = __webpack_require__(2);
var external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default = /*#__PURE__*/__webpack_require__.n(external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass__);

// EXTERNAL MODULE: external {"amd":"uu5g04","commonjs":"uu5g04","commonjs2":"uu5g04","root":"UU5"}
var external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__ = __webpack_require__(3);
var external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default = /*#__PURE__*/__webpack_require__.n(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__);

// EXTERNAL MODULE: external {"amd":"uu5g04-bricks","commonjs":"uu5g04-bricks","commonjs2":"uu5g04-bricks","root":"UU5.Bricks"}
var external___amd___uu5g04_bricks___commonjs___uu5g04_bricks___commonjs2___uu5g04_bricks___root___UU5_Bricks__ = __webpack_require__(4);
var external___amd___uu5g04_bricks___commonjs___uu5g04_bricks___commonjs2___uu5g04_bricks___root___UU5_Bricks___default = /*#__PURE__*/__webpack_require__.n(external___amd___uu5g04_bricks___commonjs___uu5g04_bricks___commonjs2___uu5g04_bricks___root___UU5_Bricks__);

// CONCATENATED MODULE: ../.tmp/temp-1.js
var ns = {
    namespace: "UuContentKit",
    cssPrefix: "uucontentkit",
    tag: function tag(component) {
        return ns.namespace + "." + component;
    },
    css: function css(component) {
        return ns.cssPrefix + "-" + component;
    }
};
/* harmony default export */ var temp_1 = (ns);
// EXTERNAL MODULE: ./bricks/block.less
var block = __webpack_require__(12);
var block_default = /*#__PURE__*/__webpack_require__.n(block);

// CONCATENATED MODULE: ./bricks/block.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var Block = external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default()({
  displayName: "Block",

  //@@viewOn:mixins
  mixins: [external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.BaseMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.ElementaryMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.NestingLevelMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.ScreenSizeMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.SectionMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.EditableMixin],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: temp_1.tag("Bricks.Block"),
    nestingLevelList: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Environment.getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: temp_1.css("bricks-block"),
      info: temp_1.css("bricks-block-info"),
      danger: temp_1.css("bricks-block-danger"),
      success: temp_1.css("bricks-block-success"),
      warning: temp_1.css("bricks-block-warning"),
      default: temp_1.css("bricks-block-default"),
      help: temp_1.css("bricks-block-help"),
      icon: temp_1.css("bricks-icon-table-cell"),
      iconContentContainer: temp_1.css("bricks-icon-content-table-cell"),
      iconContent: temp_1.css("bricks-icon-content"),
      content: temp_1.css("bricks-content")
    },
    editableComponent: temp_1.tag("BricksEditable.Block")
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    type: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string,
    icon: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string,
    iconContent: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string,
    content: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.oneOfType([external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.array, external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string]),
    header: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string,
    footer: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps

  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getChild: function _getChild() {
    if (this.isXs()) {
      return this._getSmallBlock();
    } else {

      // prefer iconContent over icon
      if (this.props.iconContent) {
        return this._getBigBlockText(this.props.iconContent);
      }

      var icon = void 0;
      switch (this.props.type) {
        case "info":
          icon = this.props.icon || "mdi-information";
          break;
        case "success":
          icon = this.props.icon || "mdi-checkbox-marked-circle";
          break;
        case "warning":
          icon = this.props.icon || "mdi-alert";
          break;
        case "danger":
          icon = this.props.icon || "mdi-alert-circle";
          break;
        case "help":
          icon = this.props.icon || "mdi-help-circle";
          break;
        case "default":
          icon = this.props.icon || "mdi-bowling";
          break;
      }
      return this._getBigBlockIcon(icon);
    }
  },
  _getSmallBlock: function _getSmallBlock() {
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
      external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
      null,
      this.getHeader() ? this.getHeaderChild() : null,
      external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
        _extends({}, this.getMainPropsToPass(), { content: null, header: null, footer: null }),
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
          { className: this.getClassName(this.props.type) },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div, { className: this.getClassName("content"),
            content: this.props.content || this.props.children })
        )
      ),
      this.getFooter() ? this.getFooterChild() : null
    );
  },
  _getBigBlockIcon: function _getBigBlockIcon(icon) {
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
      external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
      null,
      this.getHeader() ? this.getHeaderChild() : null,
      external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
        _extends({}, this.getMainPropsToPass(), { content: null, header: null, footer: null }),
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
          { className: this.getClassName(this.props.type) },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
            external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Span,
            { className: this.getClassName("icon") },
            external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Icon, { icon: icon })
          ),
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div, { className: this.getClassName("content"),
            content: this.props.content || this.props.children })
        )
      ),
      this.getFooter() ? this.getFooterChild() : null
    );
  },
  _getBigBlockText: function _getBigBlockText(text) {
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
      external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
      null,
      this.getHeader() ? this.getHeaderChild() : null,
      external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
        _extends({}, this.getMainPropsToPass(), { content: null, header: null, footer: null }),
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
          { className: this.getClassName(this.props.type) },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
            external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Span,
            { className: this.getClassName("iconContentContainer") },
            external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
              external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
              { className: this.getClassName("iconContent") },
              external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div, { content: text })
            )
          ),
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div, { className: this.getClassName("content"), content: this.props.content || this.props.children })
        )
      ),
      this.getFooter() ? this.getFooterChild() : null
    );
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function render() {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

/* harmony default export */ var bricks_block = (Block);
// CONCATENATED MODULE: ./bricks/inject-block.js
var inject_block__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var inject_block_injectBlock = function injectBlock(type) {
  var InjectBlock = external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default()({
    displayName: "InjectBlock",

    //@@viewOn:mixins
    mixins: [external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.BaseMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.SectionMixin],
    //@@viewOff:mixins

    //@@viewOn:statics
    statics: {
      tagName: temp_1.tag("Bricks.Block" + type.charAt(0).toUpperCase() + type.slice(1)),
      opt: {
        hoc: true
      }
    },
    //@@viewOff:statics

    //@@viewOn:propTypes
    propTypes: {
      content: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.oneOfType([external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.array, external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string])
    },
    //@@viewOff:propTypes

    //@@viewOn:standardComponentLifeCycle
    //@@viewOff:standardComponentLifeCycle

    //@@viewOn:interface
    //@@viewOff:interface

    //@@viewOn:overridingMethods
    //@@viewOff:overridingMethods

    //@@viewOn:componentSpecificHelpers
    //@@viewOff:componentSpecificHelpers

    //@@viewOn:render
    render: function render() {
      var content = this.props.content || this.props.children;
      return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(bricks_block, inject_block__extends({}, this.props, { content: content, type: type }));
    }
    //@@viewOff:render

  });

  return InjectBlock;
};

/* harmony default export */ var inject_block = (inject_block_injectBlock);
// EXTERNAL MODULE: external {"amd":"uu5g04-forms","commonjs":"uu5g04-forms","commonjs2":"uu5g04-forms","root":"UU5.Forms"}
var external___amd___uu5g04_forms___commonjs___uu5g04_forms___commonjs2___uu5g04_forms___root___UU5_Forms__ = __webpack_require__(7);
var external___amd___uu5g04_forms___commonjs___uu5g04_forms___commonjs2___uu5g04_forms___root___UU5_Forms___default = /*#__PURE__*/__webpack_require__.n(external___amd___uu5g04_forms___commonjs___uu5g04_forms___commonjs2___uu5g04_forms___root___UU5_Forms__);

// EXTERNAL MODULE: ./bricks/table-cell-text-input.less
var table_cell_text_input = __webpack_require__(15);
var table_cell_text_input_default = /*#__PURE__*/__webpack_require__.n(table_cell_text_input);

// CONCATENATED MODULE: ./bricks/table-cell-text-input.js










var TableCellTextInput = external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default()({
  displayName: "TableCellTextInput",

  //@@viewOn:mixins
  mixins: [external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].BaseMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].PureRenderMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].ElementaryMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].NestingLevelMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].ContentMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].ColorSchemaMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Forms"].InputMixin],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: temp_1.tag("TableCell"),
    nestingLevelList: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Environment"].getNestingLevelList('bigBoxCollection', 'inline'),
    classNames: {
      main: temp_1.css("table-cell-text-input")
      //bg: 'uu5-common-bg'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    data: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string,
    setFocus: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.func
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function getInitialState() {
    this._preventBlur = false;
    this._modalOpen = false;
    return {
      value: this.props.data,
      phase: "default"
    };
  },


  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.data });
  },

  componentDidMount: function componentDidMount() {
    this._dccEditor = this.getParentByType("hasUuDccCommonDccMixin");
  },

  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getChild: function _getChild() {
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div, this._prepareProps());
  },
  _prepareProps: function _prepareProps() {
    var _this = this;

    var mainProps = this.getMainPropsToPass();
    mainProps.mainAttrs = {
      onMouseOver: function onMouseOver() {
        if (!_this._preventBlur) {
          _this.setState({ phase: "hover" });
        }
      },
      onMouseLeave: function onMouseLeave() {
        _this._preventBlur ? null : _this.setState({ phase: "default" });
      }
    };
    mainProps.content = this._getContent();
    return mainProps;
  },
  _getContent: function _getContent() {
    var _this2 = this;

    if (this.state.phase === "default") {
      return this.state.value;
    } else if (this.state.phase === "hover") {
      return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div,
        { className: "testdiv" },
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div, { content: this.state.value }),
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Button,
          { className: "button-open-modal", mainAttrs: {
              onMouseDown: function onMouseDown() {
                _this2._openModal();
                _this2._modalOpen = true;
              }
            } },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Icon, { icon: "mdi-arrow-expand" })
        )
      );
    } else {
      this._preventBlur = true;
      var uu5StringEditor = external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].Tools.findComponent("UU5.CodeKit.Uu5StringEditor", {
        focus: true,
        value: this.state.value,
        maxRows: 1000,
        height: "0px",
        fontSize: 14,
        rows: 0,
        showGutter: false,
        wrapEnabled: true,
        onChange: function onChange(opt) {
          return _this2.setState({ value: opt.value });
        },
        ref_: function ref_(textIcon) {
          return _this2._editoruu5 = textIcon;
        }
      });
      return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div,
        { className: "div-uu5stringeditor div-uu5stringeditor-focused" },
        uu5StringEditor,
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Button,
          { className: "button-open-modal",
            mainAttrs: {
              onMouseDown: function onMouseDown() {
                _this2._openModal();
                _this2._modalOpen = true;
              }
            } },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Icon, { icon: "mdi-arrow-expand" })
        )
      );
    }
  },
  doFocus: function doFocus() {
    this._preventBlur = true;
    this.setState({ phase: "focus" });
  },
  doBlur: function doBlur() {
    this._preventBlur = false;
    this.setState({ phase: "default" });
  },
  _openModal: function _openModal() {
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_START_PROCESS", {
      componentId: this.getId(),
      content: this._openModalEdit()
    });
  },
  _openModalEdit: function _openModalEdit() {
    var _this3 = this;

    return {
      className: "uudcc-modal-uu5string",
      size: "l",
      header: external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div, { className: "uu-dockit-form-header",
        content: external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Lsi, { lsi: { cs: "Úprava buňky", en: "Edit cell" } }) }),
      content: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].Tools.findComponent("UuDcc.Bricks.UuDccCodeEditor", {
        save: function save(data) {
          return _this3._saveFromModalToState(data);
        },
        close: function close() {
          return _this3._closeModal();
        },
        data: this.state.value,
        dccCaptionsLsi: this._dccEditor.getLsi()
      })
    };
  },
  _saveFromModalToState: function _saveFromModalToState(newText) {
    this._modalOpen = false;
    this._preventBlur = true;
    this.setState({ value: newText });
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_END_PROCESS", { componentId: this.getId() });
    this.props.setFocus();
  },
  _closeModal: function _closeModal() {
    this._modalOpen = false;
    this._preventBlur = true;
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_END_PROCESS", { componentId: this.getId() });
    this.props.setFocus();
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function render() {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

/* harmony default export */ var bricks_table_cell_text_input = (TableCellTextInput);
// EXTERNAL MODULE: ./bricks/basic-info.less
var basic_info = __webpack_require__(17);
var basic_info_default = /*#__PURE__*/__webpack_require__.n(basic_info);

// CONCATENATED MODULE: ./bricks/basic-info.js













var BasicInfo = external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default()({
  displayName: "BasicInfo",

  //@@viewOn:mixins
  mixins: [external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.BaseMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.NestingLevelMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.EditableMixin, external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Forms.FormMixin],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: temp_1.tag("Bricks.BasicInfo"),
    nestingLevelList: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Environment.getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: temp_1.css("bricks-basic-info"),
      difForm: "basic-info-div-form"
    }
  },

  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    data: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.arrayOf(external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.arrayOf(external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string)),
    id: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function getDefaultProps() {
    return {
      data: [["", ""]]
    };
  },

  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      data: JSON.parse(JSON.stringify(nextProps.data))
    });
  },

  componentDidMount: function componentDidMount() {
    this._clickListener = window.addEventListener("click", this._handleClickEvent);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("click", this._handleClickEvent);
  },
  getInitialState: function getInitialState() {
    this._refy = {};
    this._focused = null;
    this.fragments = [["", ""]];
    return {
      editation: false,
      data: this.props.data
    };
  },

  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  initComponentFragmentation: function initComponentFragmentation(dccCallback) {
    //on start editation it returns [{data: uu5string, onDataChange: ()=>{callback}}]
    this.dccCallback = dccCallback;
    this._parseDataToFragments(this.state.data, dccCallback);
  },

  //on end editation reset dccmode to show
  initComponentDefragmentation: function initComponentDefragmentation() {
    //clean fragments
  },

  //@@viewOff:interface

  //@@viewOn:overridingMethods
  _handleClickEvent: function _handleClickEvent(evt) {
    if (this.state.editation) {
      if (!this._freshFocus && this._focused != null && this._domNode !== evt.target) {
        this._refy[this._focused].doBlur();
        this._focused = null;
      } else {
        this._freshFocus = false;
      }
    }
  },
  forceEndEditationHandler_: function forceEndEditationHandler_() {
    var _this = this;

    return {
      callback: function callback() {
        return _this.setState({
          data: JSON.parse(JSON.stringify(_this.props.data))
        });
      }
    };
  },
  _updateSingleFragment: function _updateSingleFragment(fragment, rowIndex, columnIndex) {
    // This part handles case, when fragment got updated by itself, not through BasicInfo data
    if (this.state.data[rowIndex][columnIndex].replace(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.REGEXP.uu5string, "") === fragment.dataModel.toString()) {
      //No dataModel update needed && keep fragments actual
      if (!this.fragments[rowIndex]) this.fragments[rowIndex] = ["", ""];
      this.fragments[rowIndex][columnIndex] = fragment;
      this.forceUpdate();
      return null;
    } else {
      return this._updateSingleDataBlock("<uu5string/>" + fragment.dataModel.toString(), rowIndex, columnIndex);
    }
  },
  _updateSingleDataBlock: function _updateSingleDataBlock(dataString, rowIndex, columnIndex) {
    var data = this.props.data.slice();
    data[rowIndex][columnIndex] = dataString;
    //When model will update, it will look for prop "data"
    return { "data": data };
  },
  _parseDataToFragments: function _parseDataToFragments(data, dccCallback) {
    if (data && data[0]) {
      for (var i = 0; i < data.length; i++) {
        /*
        * new data has all same table fields
        * 1 check if data same for the component
        * 2 check if fragment has same content as new data
        * */
        for (var j = 0; j < data[i].length; j++) {
          if (this.fragments[i] && this.fragments[i][j].dataModel && this.fragments[i][j].dataModel.toString() === data[i][j].replace(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Common.REGEXP.uu5string, "")) {
            //Skip fragment update
          } else {
            this._createFragment(data[i][j], i, j, dccCallback);
          }
        }
      }
    }
  },
  _createFragment: function _createFragment(dataString, rowIndex, columnIndex, dccCallback) {
    dccCallback(dataString, function (component, fragment) {
      //Update single fragment callback
      return component._updateSingleFragment(fragment, rowIndex, columnIndex);
    });
  },


  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getStateFromChildren: function _getStateFromChildren() {
    var cells = this.getValues();
    var newData = new Array();
    for (var i = 0; i < this.state.data.length; i++) {
      newData[i] = new Array(2);
    }
    Object.keys(cells).forEach(function (key) {
      return newData[key.split("-")[0]][key.split("-")[1]] = cells[key];
    });
    return newData;
  },
  _save: function _save() {
    this.endEditation({ "data": this._getStateFromChildren() });
  },
  _cancel: function _cancel() {
    var _this2 = this;

    this.endEditation(null, function () {
      return _this2.setState({ data: JSON.parse(JSON.stringify(_this2.props.data)) });
    });
  },
  _openContextMenu: function _openContextMenu(index, evt) {
    console.log(this.state.editation);
    if (this.state.editation) {
      evt.preventDefault();
      this._rowEditNumber = index;
      this._contextMenu.open({ event: evt });
    }
  },
  _addOrRemoveRow: function _addOrRemoveRow(type) {
    var index = this._rowEditNumber;
    var currentState = this._getStateFromChildren();
    var newState = [];
    if (type === 1) {
      for (var i = 0; i < currentState.length; i++) {
        if (i == index) {
          newState.push(["", ""]);
          newState.push(currentState[i]);
        } else {
          newState.push(currentState[i]);
        }
      }
    } else if (type === 2) {
      for (var _i = 0; _i < currentState.length; _i++) {
        if (_i == index) {
          newState.push(currentState[_i]);
          newState.push(["", ""]);
        } else {
          newState.push(currentState[_i]);
        }
      }
    } else if (type === 3) {
      for (var _i2 = 0; _i2 < currentState.length; _i2++) {
        if (_i2 != index) {
          newState.push(currentState[_i2]);
        }
      }
    }
    this.setState({ data: newState });
  },
  _getContextMenu: function _getContextMenu() {
    var _this3 = this;

    if (this.state.editation) {
      return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.ContextMenu,
        { ref_: function ref_(contextMenu) {
            return _this3._contextMenu = contextMenu;
          } },
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.ContextMenu.Item, {
          label: "Vlo\u017Eit \u0159\xE1dek p\u0159ed",
          onClick: function onClick(evt) {
            _this3._addOrRemoveRow(1), evt.component.close();
          }
        }),
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.ContextMenu.Item, {
          label: "Vlo\u017Eit \u0159\xE1dek za",
          onClick: function onClick(evt) {
            _this3._addOrRemoveRow(2), evt.component.close();
          }
        }),
        this.state.data.length > 1 && external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.ContextMenu.Item, {
          label: "Smazat \u0159\xE1dek",
          onClick: function onClick(evt) {
            _this3._addOrRemoveRow(3), evt.component.close();
          }
        })
      );
    }
  },
  _getChild: function _getChild() {
    var _this4 = this;

    var mainProps = this.getMainPropsToPass();
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
      external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.LsiContext,
      null,
      external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
        external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Div,
        { className: this.getClassName("main") + "_root", ref: function ref(domNode) {
            return _this4._domNode = domNode;
          } },
        external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Forms.Form,
          { className: this.getClassName("difForm"), ref_: function ref_(formA) {
              return _this4._form = formA;
            },
            onSave: this.state.editation ? function () {
              return _this4._save();
            } : null,
            onCancel: this.state.editation ? function () {
              return _this4._cancel();
            } : null },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
            external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Table,
            mainProps,
            external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
              external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Table.TBody,
              null,
              this._renderBasicInfoRows()
            )
          ),
          this.state.editation && external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Forms.Controls, { className: "div-buttons" })
        ),
        this.state.editation && this._getContextMenu()
      )
    );
  },
  _setFocus: function _setFocus(index) {
    if (this._focused != null) {
      this._refy[this._focused].doBlur();
    }
    this._refy[index].doFocus();
    this._focused = index;
    this._freshFocus = true;
  },
  _renderBasicInfoRows: function _renderBasicInfoRows() {
    var _this5 = this;

    var data = this.state.data;
    return data && data.map(function (row, i) {
      if (row.length !== 0) {
        var rowId = "basic-info-tr_" + i;
        return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
          external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Table.Tr,
          { key: rowId, id: rowId, allowTags: ["UuDocKit.Bricks.TableCell"],
            mainAttrs: { onContextMenu: function onContextMenu(evt) {
                return _this5._openContextMenu(i, evt);
              } } },
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Table.Th, { key: "no-edit-first",
            mainAttrs: { onClick: _this5.state.editation ? function () {
                return _this5._setFocus(i + "-0");
              } : null },
            content: //if this.state.editation => data showed, not fragment
            _this5.state.editation ? external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(bricks_table_cell_text_input, {
              setFocus: function setFocus() {
                return _this5._setFocus(i + "-0");
              },
              ref_: function ref_(toto) {
                return _this5._refy[i + "-0"] = toto;
              },
              key: "label-cell-content", name: i + "-0",
              pureRender: true,
              id: i + "-0",
              data: data[i][0]
            }) :
            //fragments will be showed only when its not state.edition, and dcc is in ModeEdit
            _this5.fragments[i] && _this5.fragments[i][0].dataModel && _this5.fragments[i][0].dataModel.toChildren() || row && row[0] }),
          external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5___default.a.Bricks.Table.Td, { key: "no-edit-second",
            mainAttrs: { onClick: _this5.state.editation ? function () {
                return _this5._setFocus(i + "-1");
              } : null },
            content: _this5.state.editation ? external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(bricks_table_cell_text_input, {
              setFocus: function setFocus() {
                return _this5._setFocus(i + "-1");
              },
              key: "value-cell-content", name: i + "-1",
              ref_: function ref_(toto) {
                _this5._refy[i + "-1"] = toto;
              },
              pureRender: true,
              id: i + "-1",
              data: data[i][1]
            }) : _this5.fragments[i] && _this5.fragments[i][1].dataModel && _this5.fragments[i][1].dataModel.toChildren() || row && row[1] })
        );
      }
    });
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function render() {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

/* harmony default export */ var bricks_basic_info = (BasicInfo);
// CONCATENATED MODULE: ./bricks/bricks.js




var BlockInfo = inject_block("info");
var BlockDanger = inject_block("danger");
var BlockWarning = inject_block("warning");
var BlockDefault = inject_block("default");
var BlockSuccess = inject_block("success");
var BlockHelp = inject_block("help");


// CONCATENATED MODULE: ./config/lsi.js


var Lsi = {

  blockEditableLabelIcon: {
    cs: "Ikona",
    en: "Icon"
  },

  blockEditableLabelText: {
    cs: "Text",
    en: "Text"
  },

  blockEditableIconPlaceholder: {
    cs: "Ponechte prázdné pro výchozí ikonu",
    en: "Leave blank for default icon"
  }

};

/* harmony default export */ var lsi = (Lsi);
// CONCATENATED MODULE: ./bricks-editable/block.js
var block__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var block_Block = external___amd___create_react_class___commonjs___create_react_class___commonjs2___create_react_class___root___createReactClass___default()({
  displayName: "Block",

  //@@viewOn:mixins
  mixins: [external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].BaseMixin],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: temp_1.tag("BricksEditable.Block"),
    nestingLevelList: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Environment"].getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: "editable-block"
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    component: external___amd___prop_types___commonjs___prop_types___commonjs2___prop_types___root___PropTypes___default.a.object
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function getDefaultProps() {
    return {
      component: null
    };
  },

  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function getInitialState() {
    // get data for form from component
    var temp = {};
    if (typeof this.props.component.getEditablePropsValues === "function") {
      temp = this.props.component.getEditablePropsValues(["icon", "content", "children"]);
    }
    temp.type = "BasicEdit";
    return temp;
  },

  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _isFalsy: function _isFalsy(elem) {
    switch (elem) {
      case null:
        return true;
      case undefined:
        return true;
      case "":
        return true;
      case 0:
        return true;
      default:
        return false;
    }
  },
  _checkValues: function _checkValues(prev, next) {
    var output = block__extends({}, next);
    for (var elem in next) {
      if (next[elem] === prev[elem] || this._isFalsy(next[elem]) && this._isFalsy(prev[elem])) {
        delete output[elem];
      }
    }
    return output;
  },
  _save: function _save(form) {
    var props = form.values;
    props.icon = props.icon ? props.icon.trim() : "";
    props.contentEditable = true;
    if (props.content) {
      if (props.content !== this.state.children) {
        var content = this._contentToString(props.content);
        props.content = content ? "<uu5string/>" + content : content;
        if (this.state.children) props.children = "";
      } else {
        delete props.content;
      }
    }
    var preProps = this.props.component.getEditablePropsValues(["icon", "contentEditable", "content", "children"]);
    props = this._checkValues(preProps, props);
    this.props.component.endEditation(props);
  },
  _cancel: function _cancel() {
    this.props.component.endEditation();
  },


  //TODO
  //change content type to uu5stringWithButton when its ready in uu5
  _getBasicEdit: function _getBasicEdit(content) {
    var _this = this;

    var props = [{
      name: "icon",
      type: "text",
      label: this.getLsiItem(lsi.blockEditableLabelIcon),
      placeholder: this.getLsiItem(lsi.blockEditableIconPlaceholder),
      value: this.state.icon
    }, {
      name: "content",
      type: "uu5string",
      label: this.getLsiItem(lsi.blockEditableLabelText),
      value: content,
      maxRows: 1000,
      rows: 5,
      showGutter: false,
      wrapEnabled: true,
      labelColWidth: "xs-12",
      inputColWidth: "xs-12",
      icon: "mdi-arrow-expand",
      props: { ref_: function ref_(input) {
          return _this._input = input;
        }, disabled: true }
    }, {
      name: "contentEditable",
      type: "bool",
      label: "Content Editable",
      value: true,
      props: { onChange: function onChange(opt) {
          opt.component.setValue(opt.value);
          if (_this._input) {
            opt.value ? _this._input.disable() : _this._input.enable();
          }
        } }
    }];
    return external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(
      external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Bricks"].Div,
      this.getMainPropsToPass(),
      external___amd___react___commonjs___react___commonjs2___react___root___React___default.a.createElement(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Forms"].PropsForm, {
        onSave: this._save,
        onCancel: this._cancel,
        labelColWidth: "xs-12",
        inputColWidth: "xs-12",
        props: props,
        uu5string: true,
        id: external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].Tools.generateUUID()
      })
    );
  },
  _getChild: function _getChild() {
    var content = this.state.children || this._contentToString(this.state.content);
    return this._getBasicEdit(content);
  },
  _contentToString: function _contentToString(content) {
    if (content) {
      if (Array.isArray(content)) {
        return content.join(" ").replace(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].REGEXP.uu5string, "");
      }
      return content.replace(external___amd___uu5g04___commonjs___uu5g04___commonjs2___uu5g04___root___UU5__["Common"].REGEXP.uu5string, "");
    }
    return "";
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function render() {
    return this._getChild();
  }
  //@@viewOff:render

});

/* harmony default export */ var bricks_editable_block = (block_Block);
// CONCATENATED MODULE: ./bricks-editable/bricks-editable.js

// CONCATENATED MODULE: ./index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Bricks", function() { return bricks_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BricksEditable", function() { return bricks_editable_namespaceObject; });




/* harmony default export */ var index = __webpack_exports__["default"] = ({ Bricks: bricks_namespaceObject, BricksEditable: bricks_editable_namespaceObject });

window.UuContentKit = window.UuContentKit || {};
window.UuContentKit.Bricks = bricks_namespaceObject;
window.UuContentKit.BricksEditable = bricks_editable_namespaceObject;

console.log("uuContentKitg01" + "-" + "1.3.0" + " \xA9 Unicorn\nTerms of Use: https://unicorn.com/tou/" + "uuContentKitg01".toLowerCase());

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./block.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./block.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".uucontentkit-bricks-block{margin:16px 0}.uucontentkit-bricks-block .uucontentkit-bricks-block-danger,.uucontentkit-bricks-block .uucontentkit-bricks-block-default,.uucontentkit-bricks-block .uucontentkit-bricks-block-help,.uucontentkit-bricks-block .uucontentkit-bricks-block-info,.uucontentkit-bricks-block .uucontentkit-bricks-block-success,.uucontentkit-bricks-block .uucontentkit-bricks-block-warning{display:grid;width:100%;grid-template-columns:65px auto;grid-template-rows:4px 48px auto}.uucontentkit-bricks-block .uucontentkit-bricks-icon-content-table-cell,.uucontentkit-bricks-block .uucontentkit-bricks-icon-table-cell{grid-column-start:1;grid-column-end:2;grid-row-start:2;grid-row-end:4}.uucontentkit-bricks-block .uucontentkit-bricks-icon-content-table-cell{vertical-align:top}.uucontentkit-bricks-block .uucontentkit-bricks-content{vertical-align:middle;padding:16px 16px 16px 0;grid-column-start:2;grid-column-end:3;grid-row-start:1;grid-row-end:4;min-width:0}@media (max-width:480px){.uucontentkit-bricks-block .uucontentkit-bricks-content{padding:16px;grid-column-start:1}}.uucontentkit-bricks-block .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{padding:8px 16px;font-size:32px;line-height:1;vertical-align:middle}.uucontentkit-bricks-block .uucontentkit-bricks-icon-content{background-color:gray;border-radius:50%;margin:10px 18px;width:27px;height:27px;font-size:32px;line-height:1;text-align:center;vertical-align:middle}.uucontentkit-bricks-block .uucontentkit-bricks-icon-content .uu5-common-div{font-size:18px;vertical-align:middle;font-weight:700}.uucontentkit-bricks-block-info{background-color:#e3f2fd}.uucontentkit-bricks-block-info .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#1976d2}.uucontentkit-bricks-block-info .uucontentkit-bricks-icon-content{background-color:#1976d2;color:#e3f2fd}.uucontentkit-bricks-block-success{background-color:#e8f5e9}.uucontentkit-bricks-block-success .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#43a047}.uucontentkit-bricks-block-success .uucontentkit-bricks-icon-content{background-color:#43a047;color:#e8f5e9}.uucontentkit-bricks-block-warning{background-color:#fff3e0}.uucontentkit-bricks-block-warning .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#ffa000}.uucontentkit-bricks-block-warning .uucontentkit-bricks-icon-content{background-color:#ffa000;color:#fff3e0}.uucontentkit-bricks-block-danger{background-color:#ffebee}.uucontentkit-bricks-block-danger .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#d32f2f}.uucontentkit-bricks-block-danger .uucontentkit-bricks-icon-content{background-color:#d32f2f;color:#ffebee}.uucontentkit-bricks-block-help{background-color:#f5f5f5}.uucontentkit-bricks-block-help .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#616161}.uucontentkit-bricks-block-help .uucontentkit-bricks-icon-content{background-color:#616161;color:#f5f5f5}.uucontentkit-bricks-block-default{background-color:#f5f5f5}.uucontentkit-bricks-block-default .uucontentkit-bricks-icon-table-cell .uu5-bricks-icon{color:#616161}.uucontentkit-bricks-block-default .uucontentkit-bricks-icon-content{background-color:#616161;color:#f5f5f5}", ""]);

// exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(16);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./table-cell-text-input.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./table-cell-text-input.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".uucontentkit-table-cell-text-input{min-height:22px;margin:-6px -16px;padding-left:16px}.uucontentkit-table-cell-text-input .button-open-modal{position:absolute;bottom:0;right:8px;z-index:999;background-color:transparent}.uucontentkit-table-cell-text-input .button-open-modal:hover{background-color:transparent}.uucontentkit-table-cell-text-input .testdiv{position:relative;background-color:#fff;outline-offset:0;outline:1px solid #e0e0e0!important;min-height:32px;padding:4px 8px;margin-left:-8px;margin-right:8px}.uucontentkit-table-cell-text-input .div-uu5stringeditor{margin-left:-16px;position:relative}.uucontentkit-table-cell-text-input .div-uu5stringeditor.div-uu5stringeditor-focused .ace_editor{outline:1px solid #2196f3!important;border:0!important}.uucontentkit-table-cell-text-input .div-uu5stringeditor .uu5-codekit-code-editor{margin-top:0;margin-bottom:0}", ""]);

// exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(18);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./basic-info.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../node_modules/postcss-loader/lib/index.js??ref--0-oneOf-2-2!../../node_modules/less-loader/dist/cjs.js!./basic-info.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(undefined);
// imports


// module
exports.push([module.i, ".uucontentkit-bricks-basic-info{font-size:auto}@media (max-width:480px){.uucontentkit-bricks-basic-info{font-size:15px}}.uucontentkit-bricks-basic-info-table .uu5-bricks-footer{margin-bottom:16px}.uucontentkit-bricks-basic-info .uu5-bricks-table-th{border:0;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;background-color:#f5f5f5;padding:12px 16px;vertical-align:middle;overflow-wrap:break-word}.basic-info-div-form{padding:0;margin:16px 0}.uucontentkit-bricks-basic-info .uu5-bricks-table-td{border:0;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:12px 16px;vertical-align:middle;overflow-wrap:break-word}.uucontentkit-bricks-basic-info .uu5-bricks-table-td:first-child,.uucontentkit-bricks-basic-info .uu5-bricks-table-th:first-child{width:200px}.uucontentkit-bricks-basic-info_root{border:3px solid transparent}.uucontentkit-bricks-basic-info{font-size:14px;color:rgba(0,0,0,.87)}.uucontentkit-bricks-basic-info .uu5-bricks-table-table{margin-top:0;table-layout:fixed}.uucontentkit-bricks-basic-info .uu5-bricks-table-tr{background-color:#fff;height:48px}@media (max-width:768px){.uucontentkit-bricks-basic-info .uu5-bricks-table-td:first-child,.uucontentkit-bricks-basic-info .uu5-bricks-table-th:first-child{width:100px;min-width:100px}}.div-buttons{margin:0 -18px;padding:4px 8px;border-top:1px solid #e0e0e0;text-align:right;background-color:#f5f5f5;min-height:48px}", ""]);

// exports


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// uu_contentkitg01.min.js